module.exports = __webpack_public_path__ + "media/images/partners/microbit-aa4ed7d5febb43ec2e6f5653b4dd3bcd.svg";